<template>
  <div class="container">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Container'
}
</script>

<style lang="sass">
@import '@/styles/variables.sass'

.container
  p,
  .container
    margin-top: $margin
    line-height: 1.4
  .container
    width: 100%
  p
    max-width: 70%
  .section-title
    margin-bottom: $margin
</style>
